import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../auth/auth';

export const authGuard: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  const userObj = localStorage.getItem(auth.AUTH_USER);
  const user = userObj ? JSON.parse(userObj) : null;

  if (auth.isAuthenticated()) {
    if (user?.must_change_password === true || user?.must_change_password === 'true' || user?.must_change_password === 1) {
      return router.createUrlTree(['/changepassword']);
    }
    return true;
  }

  return router.createUrlTree(['/login']);
};
